


























import Vue from 'vue';

export default Vue.extend({
  name: 'ProductReviewCard',
  props: {
    review: {
      type: Object as () => ProductReviewResponse,
      required: true,
    },
    primaryColor: {
      type: String,
      default: '',
    },
    iconType: {
      type: String,
      default: 'stars',
    },
  },
});
